import React, { useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "react-lazy-load-image-component/src/effects/blur.css";
import "react-image-gallery/styles/css/image-gallery.css";
import {
  SignUpForm,
  LogInForm,
  ForgotPasswordForm,
  ResetPasswordForm,
  VerifyOtp,
} from "./authentication";
import {
  MainDashBoard,
  BuyProperty,
  BuyPropertylist,
  RentProperty,
  SoldProperty,
  NewHomes,
  NewApartments,
  ExploreMapPage,
  NewHomesDetail,
  FindAgent,
  Commercial,
  AgentAppraisal,
  DetailedViewProperty,
  AgencyProfile,
  AgentProfile,
  AgentReview,
  UserDashBoard,
  MySavedProperty,
  AdvertiseScreen,
  AccountSetting,
  Inspection,
  SaveSearch,
  Contactus,
  NavBar,
  Footer,
  Collections,
  NearbyCollection,
} from "./components";
import BuyPropertySearch from "./components/BuyProperty/BuyPropertySearch";
import RentPropertySearch from "./components/RentProperty/RentPropertySearched";
import SoldPropertySearch from "./components/SoldProperty/SoldPropertySearch";
import SearchbyAddress from "./components/searchByAddress/SearchByAddress";
import Advertise from "./components/Advertise/Advertise";
import Blogs from "./components/blogs/Blogs";
import BlogDetail from "./components/blogs/BlogDetails";
import useScrollRestoration from "./Hooks/useScrollRestoration/useScrollRestoration";
import NavBarHomeScreen from "./components/NavBar/NavBarHomeScreen";
import CollectionDetailScreen from "./components/Collections/CollectionDetailScreen";
import { useCollections } from "./Hooks/useCollections/useCollections";
import InspectionsCollection from "./components/Collections/InspectionsCollection";
import RentalApplication from "./components/RentalApplication/RentalApplication";
import PersonalDetails from "./components/RentalApplication/PersonalDetails";
import AboutMe from "./components/RentalApplication/AboutMe";
import AddressHistory from "./components/RentalApplication/AddressHistory";
import Employment from "./components/RentalApplication/Employment";
import Finances from "./components/RentalApplication/Finances";
import IdentityDocuments from "./components/RentalApplication/IdentityDocuments";
import HouseholdPeople from "./components/RentalApplication/HouseholdPeople";
import HouseholdPets from "./components/RentalApplication/HouseholdPets";

function App() {
  useScrollRestoration();
  // Preload collections once when the app mounts so they are cached globally.
  useCollections();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const getPath = useLocation().pathname.split("/")?.[2];
  const checkAuth = localStorage.getItem("Token");
  const location = useLocation();
  const path = location.pathname;
  useEffect(() => {
    if (checkAuth === undefined || checkAuth === null) {
      if (getPath === "reset-password") {
      } else {
        if (getPath === "log-in") {
          navigate("/");
        }
      }
    }
  }, [checkAuth]);
  const [search, setSearch] = useState(undefined);
  const hideNavbar =
    path.startsWith("/auth") ||
    path === "/log-in" || path == "/VerifyOtp" ||
    path === "/sign-up";
  return (
    <>
      {/* {path !== "/log-in" &&
        path !== "/auth/forgot-password" &&
        path !== "/sign-up" && <NavBar setSearch={setSearch} />} */}
      {/* <ScrollToTopMain /> */}
      {!hideNavbar && <NavBarHomeScreen />}
      <Routes>
        <Route
          exact
          path="/"
          element={<MainDashBoard setSearch={setSearch} />}
        />
        <Route exact path="/buy" element={<BuyProperty />} />
        <Route
          exact
          path="/buy/searched/:data"
          element={<BuyPropertySearch />}
        />
        <Route exact path="/rental-applications" element={<RentalApplication />} />
        <Route
          exact
          path="/rental-applications/personal-details"
          element={<PersonalDetails />}
        />
        <Route
          exact
          path="/rental-applications/about-me"
          element={<AboutMe />}
        />
        <Route
          exact
          path="/rental-applications/address-history"
          element={<AddressHistory />}
        />
        <Route
          exact
          path="/rental-applications/employment"
          element={<Employment />}
        />
        <Route
          exact
          path="/rental-applications/finances"
          element={<Finances />}
        />
        <Route
          exact
          path="/rental-applications/identity-documents"
          element={<IdentityDocuments />}
        />
        <Route
          exact
          path="/rental-applications/household/people"
          element={<HouseholdPeople />}
        />
        <Route
          exact
          path="/rental-applications/household/pets"
          element={<HouseholdPets />}
        />
        {/* <Route path="/buy/:encryptedData" element={<BuyProperty />} /> */}

        <Route path="/buy/list-1" element={<BuyPropertylist />} />
        <Route exact path="/rent" element={<RentProperty />} />
        <Route
          exact
          path="/rent/searched/:data"
          element={<RentPropertySearch />}
        />
        <Route
          exact
          path="address/searched"
          element={<SearchbyAddress search={search} />}
        />
        <Route exact path="/sold" element={<SoldProperty />} />
        <Route
          exact
          path="/sold/searched/:data"
          element={<SoldPropertySearch />}
        />
        <Route exact path="/new-homes" element={<NewApartments />} />
        <Route exact path="/new-homes/results" element={<NewHomes />} />
        <Route exact path="/new-homes/map" element={<ExploreMapPage />} />
        <Route exact path="/new-homes/development/:id" element={<NewHomesDetail />} />

        <Route exact path="/find-agents" element={<FindAgent />}>
          <Route path="/find-agents/:key" element={<FindAgent />} />
        </Route>
        <Route exact path="/commercial" element={<Commercial />} />
        <Route exact path="/blog" element={<Blogs />} />
        <Route exact path="/blog/:id" element={<BlogDetail />} />

        <Route exact path="/appraisal/:id" element={<AgentAppraisal />} />
        <Route
          exact
          path="/property-house/:id"
          element={<DetailedViewProperty />}
        />
        <Route exact path="/agency-profile/:id" element={<AgencyProfile />} />
        <Route exact path="/agent-profile/:id" element={<AgentProfile />} />
        <Route exact path="/agent-review/:id" element={<AgentReview />} />
        {/* <Route path="/terms-and-conditions" element={<Terms />} />
        <Route path="/privacy-policy" element={<Privacy />} /> */}


        <Route exact path="/dashboard" element={<UserDashBoard />} />
        <Route exact path="/my-saved-property" element={<MySavedProperty />} />
        <Route exact path="/collections" element={<Collections />} />
        <Route exact path="/collections/inspections" element={<InspectionsCollection />} />
        <Route exact path="/collections/nearby" element={<NearbyCollection />} />
        <Route exact path="/collections/:collectionId" element={<CollectionDetailScreen />} />
        <Route exact path="/account-settings" element={<AccountSetting />} />
        <Route exact path="/uses-for-advertise" element={<AdvertiseScreen />} />
        <Route exact path="/inspection" element={<Inspection />} />
        <Route exact path="/SaveSearch" element={<SaveSearch />} />
        <Route exact path="/contactus" element={<Contactus />} />

        <Route exact path="/VerifyOtp" element={<VerifyOtp />} />
        <Route exact path="/log-in" element={<LogInForm />} />
        <Route exact path="/sign-up" element={<SignUpForm />} />
        <Route
          exact
          path="/auth/forgot-password"
          element={<ForgotPasswordForm />}
        />
        <Route
          exact
          path="/auth/reset-password/:id/:token"
          element={<ResetPasswordForm />}
        />
        {/* Advertise route */}
        <Route exact path="/advertise" element={<Advertise />} />
      </Routes>
      {!hideNavbar && <Footer />}
    </>
  );
}

export default App;
